import { render, staticRenderFns } from "./getTac.vue?vue&type=template&id=6ad71f17&lang=pug"
import script from "./getTac.vue?vue&type=script&lang=js"
export * from "./getTac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports